"use strict";

import "materialize-css/dist/css/materialize.min.css";
import M from "materialize-css";
import "@fontsource/passion-one";
import "fullpage.js/dist/fullpage.min.css";
import fullpage from "fullpage.js";

import { Elm } from "./Main.elm";

const app = Elm.Main.init();
const isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;

function getVoicesAsync() {
  return new Promise((resolve) => {
    const initial = window.speechSynthesis.getVoices();
    if (initial.length) {
      resolve(initial);
      return;
    }
    window.speechSynthesis.addEventListener(
      "voiceschanged",
      () => resolve(window.speechSynthesis.getVoices()),
      { once: true },
    );
  });
}

app.ports.speakIt.subscribe(async function (text) {
  if (!text || !("speechSynthesis" in window)) {
    return;
  }

  const repRe = new RegExp("\\brep\\b", "gi");
  const breakRe = new RegExp("break\\b", "gi");
  // Google web TTS is crazy: "rep" = "waheedah"?
  const fixed = text.replace(repRe, "repp").replace(breakRe, "brake");

  const voices = await getVoicesAsync();
  if (!voices.length) {
    console.warn(
      "[speakIt] no TTS voices available — install a synthesizer (e.g. espeak-ng)",
    );
    return;
  }

  const msg = new SpeechSynthesisUtterance(fixed);
  msg.volume = isFirefox ? 0.75 : 0.9;
  msg.pitch = 0.7; // 0 to 2
  msg.rate = 0.8;
  // Maximum hilarity on Chrome
  msg.lang = isFirefox ? "en" : "de";
  msg.onerror = (e) => console.error("[speakIt] error:", e.error);
  window.speechSynthesis.speak(msg);
});

window.addEventListener("load", function (event) {
  // Mainly for Firefox
  document.querySelectorAll("a").forEach(function (el) {
    el.addEventListener("mouseup", function (e) {
      e.currentTarget.blur();
    });
  });

  // Mobile menu
  const elems = document.querySelectorAll(".sidenav");
  M.Sidenav.init(elems, {});

  // Set up full page stuff
  new fullpage("#fullpage", {
    anchors: ["home", "why", "gym", "hipster", "ai", "tech", "api"],
    verticalCentered: false,
    animateAnchor: true,
    menu: "#main-nav ul",
    paddingTop: "3em",
    navigation: true,
    licenseKey: "E9FA420D-F2054BF8-B0A1B7DC-4B163A8B",
    v2compatible: false,
    scrollingSpeed: 800,
    onLeave: function (last, next, direction) {
      const mcb = document.getElementById("mc-bain");
      const sav = document.getElementById("savant");
      const bot = document.getElementById("ai-bot");

      if (last.anchor === "why") {
        mcb.style.opacity = 0;
      } else if (next.anchor === "why") {
        sav.style.opacity = 0;
        bot.style.opacity = 0;
        setTimeout(function () {
          mcb.style.opacity = "1.0";
        }, 700);
      }
      if (last.anchor === "hipster") {
        sav.style.opacity = 0;
      } else if (next.anchor === "hipster") {
        sav.style.opacity = 0;
        bot.style.opacity = 0;
        setTimeout(function () {
          sav.style.opacity = "1.0";
        }, 1200);
      }
      if (last.anchor === "ai") {
        bot.style.opacity = 0;
      } else if (next.anchor === "ai") {
        sav.style.opacity = 0;
        mcb.style.opacity = 0;
        setTimeout(function () {
          bot.style.opacity = "1.0";
        }, 800);
      } else if (["tech", "api"].indexOf(next.anchor) >= 0) {
        sav.style.opacity = 0;
        mcb.style.opacity = 0;
        bot.style.opacity = 0;
      }
    },
  });
});
